export default __webpack_public_path__ + "static/media/amazon.bb3c500b.svg";